import { render } from "./YogaOnlineContent.vue?vue&type=template&id=594e9d56"
import script from "./YogaOnlineContent.vue?vue&type=script&lang=js"
export * from "./YogaOnlineContent.vue?vue&type=script&lang=js"

import "./YogaOnlineContent.vue?vue&type=style&index=0&id=594e9d56&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__